(function () {
  // Fade-in on load
  const content = document.querySelector('[data-fc-hero-content]');
  if (content) {
    setTimeout(() => content.setAttribute('data-loaded', 'true'), 120);
  }

  // Pillow counter — deterministic, time-based, globally synchronized.
  // Every visitor sees the same number at the same wall-clock instant.
  //
  // Cadence: +500 / day, smoothly distributed → one +1 every 172.8 seconds.
  // The displayed number is a pure function of UTC time, so refreshing,
  // opening a new tab, or two users in different cities will all agree.
  const numEl = document.querySelector('[data-fc-counter-num]');
  if (!numEl) return;

  const ANCHOR_MS    = Date.UTC(2026, 5, 9, 0, 0, 0); // 2026-06-09 00:00 UTC
  const ANCHOR_COUNT = 1100000;                       // count at anchor instant
  const PER_DAY      = 500;
  const TICK_MS      = 86400000 / PER_DAY;            // 172,800 ms = ~2.88 min per +1

  function compute() {
    const elapsed = Date.now() - ANCHOR_MS;
    return ANCHOR_COUNT + Math.max(0, Math.floor(elapsed / TICK_MS));
  }

  let current = compute();
  numEl.textContent = current.toLocaleString('en-US');

  // Re-poll every 15s so the number visibly ticks up about every 3 minutes
  // without any per-session randomness. Two browsers open side-by-side will
  // bump in lockstep.
  setInterval(() => {
    const next = compute();
    if (next !== current) {
      current = next;
      numEl.textContent = current.toLocaleString('en-US');
    }
  }, 15000);
})();
